'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _iBem = require('../../../i-bem/i-bem.react');

var _bIServices = (require('./../../../i-services/i-services.react.js').default || require('./../../../i-services/i-services.react.js')).applyDecls();

var _bIServices2 = _interopRequireDefault(_bIServices);

var _bUser2TI18n = function () {
    var core = require('bem-i18n');

    if (process.env.BEM_LANG ? process.env.BEM_LANG === 'ru' : process.env.REACT_APP_BEM_LANG ? process.env.REACT_APP_BEM_LANG === 'ru' : 'en' === 'ru') {
        return core().decl(require('./../../user2.i18n/ru'))('user2');
    }

    if (process.env.BEM_LANG ? process.env.BEM_LANG === 'en' : process.env.REACT_APP_BEM_LANG ? process.env.REACT_APP_BEM_LANG === 'en' : 'en' === 'en') {
        return core().decl(require('./../../user2.i18n/en'))('user2');
    }

    if (process.env.BEM_LANG ? process.env.BEM_LANG === 'be' : process.env.REACT_APP_BEM_LANG ? process.env.REACT_APP_BEM_LANG === 'be' : 'en' === 'be') {
        return core().decl(require('./../../user2.i18n/be'))('user2');
    }

    if (process.env.BEM_LANG ? process.env.BEM_LANG === 'id' : process.env.REACT_APP_BEM_LANG ? process.env.REACT_APP_BEM_LANG === 'id' : 'en' === 'id') {
        return core().decl(require('./../../user2.i18n/id'))('user2');
    }

    if (process.env.BEM_LANG ? process.env.BEM_LANG === 'kk' : process.env.REACT_APP_BEM_LANG ? process.env.REACT_APP_BEM_LANG === 'kk' : 'en' === 'kk') {
        return core().decl(require('./../../user2.i18n/kk'))('user2');
    }

    if (process.env.BEM_LANG ? process.env.BEM_LANG === 'tr' : process.env.REACT_APP_BEM_LANG ? process.env.REACT_APP_BEM_LANG === 'tr' : 'en' === 'tr') {
        return core().decl(require('./../../user2.i18n/tr'))('user2');
    }

    if (process.env.BEM_LANG ? process.env.BEM_LANG === 'tt' : process.env.REACT_APP_BEM_LANG ? process.env.REACT_APP_BEM_LANG === 'tt' : 'en' === 'tt') {
        return core().decl(require('./../../user2.i18n/tt'))('user2');
    }

    if (process.env.BEM_LANG ? process.env.BEM_LANG === 'uk' : process.env.REACT_APP_BEM_LANG ? process.env.REACT_APP_BEM_LANG === 'uk' : 'en' === 'uk') {
        return core().decl(require('./../../user2.i18n/uk'))('user2');
    }

    if (process.env.NODE_ENV === 'development') {
        process.env.BEM_LANG && console.error('No match of process.env.BEM_LANG { ' + process.env.BEM_LANG + ' } in provided langs: { ru, en, be, id, kk, tr, tt, uk }');
        process.env.REACT_APP_BEM_LANG && console.error('No match of process.env.REACT_APP_BEM_LANG { ' + process.env.REACT_APP_BEM_LANG + ' } in provided langs: { ru, en, be, id, kk, tr, tt, uk }');
    }

    return function () {};
}();

var _bUser2TI18n2 = _interopRequireDefault(_bUser2TI18n);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _iBem.declMod)({ action: 'mail-compose' }, {
    block: 'user2',
    elem: 'menu-item',
    attrs: function attrs(_ref) {
        var contentRegion = _ref.contentRegion;

        return _extends({}, this.__base.apply(this, arguments), {
            href: _bIServices2.default.serviceUrl('mail') + '/compose'
        });
    },
    content: function content() {
        return (0, _bUser2TI18n2.default)('mail_compose');
    }
});